module.exports = __webpack_public_path__ + "img/31.ea3432ef.png";